import { render } from "./Tos.vue?vue&type=template&id=aae409f8&scoped=true"
import script from "./Tos.vue?vue&type=script&lang=js"
export * from "./Tos.vue?vue&type=script&lang=js"

import "./Tos.vue?vue&type=style&index=0&id=aae409f8&scoped=true&lang=css"

import exportComponent from "/builds/site-palette/palette.site-new/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-aae409f8"]])

export default __exports__